import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { GenericTryPluginModal } from "./GenericTryPluginModal"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUserID } from "user/profile/selectors"
import { createVideoFlight } from "features/pubsub/entityActions/flights/video"
import { SampleDataFlightKey } from "@nova/constants"
import { hideGlobalModal } from "runlevel/actions"

export const TryVideoModal = () => {
    const dispatch = useAppDispatch()
    const userId = useAppSelector(selectUserID)

    const createSampleVideoFlight = () => {
        if (!userId) return

        dispatch(
            createVideoFlight({
                data: {
                    createdBy: {
                        userId,
                    },
                },
                context: {
                    sampleDataFlightKey: SampleDataFlightKey.fmv1,
                },
            })
        )

        dispatch(hideGlobalModal())
    }

    return (
        <GenericTryPluginModal
            pluginId={NovaPluginIds.Video}
            title="Try Video Playback"
            subtitle="See every flight, frame by frame."
            body="Upload your drone video and watch it play back with full context. We sync your footage with the drone's exact position and field of view on the map, so you can track what you saw and where you saw it."
            footer="Use pre-loaded sample data to experiene this powerful tool."
            buttonTitle="Use Sample Data"
            onButtonClick={createSampleVideoFlight}
        />
    )
}
